import {TYPE_GET_RAW, useFetcherSelector} from "../../mrf/redux/ReduxHelper";
import T from "../../mrf/utils/T";
import {Col} from "../../mrf/view/Grid";
import DashboardCard from "./DashboardCard";
import {DocumentCheckmark} from "@styled-icons/fluentui-system-filled/DocumentCheckmark";
import Link from "styles/basic/Link";

export default function MctaCard() {

    const mctaData = useFetcherSelector({
        selector: state => state?.resources?.mctaCard,
        type: TYPE_GET_RAW,
        resource: 'mctaCard',
        endpoint: '/api/reports/mctaDashboard',
        condition: () => true,
    });

    return (
        <DashboardCard 
            icon={DocumentCheckmark} 
            title='MCTA'
            contentClassName='content-start items-start'
            >
                <Col size={12}>
                    <div className='flex flex-col gap-2'>
                        <div>
                            <b><T>Ongoing Transfers</T>:</b>{' '}
                            <Link href={'reports/communicationTransfers/search'}>{mctaData?.transfers}</Link>
                        </div>
                        <div>
                            <b><T>Pending Assignments</T>:</b>{' '}
                            <Link href={'reports/communicationAssignments/search?status=0'}>{mctaData?.assignments}</Link>
                        </div>
                    </div>
            </Col>
        </DashboardCard>
    );
}